module.exports = __webpack_public_path__ + "static/media/GM.39426edb.png";